export default "__VITE_ASSET__DxLaiW2U__"